<template>
    <div class="detail" id="detail">
        <div ref="detail" class="detailPostion"></div>
        <div class="detail-inner">
            <breadcrumb :nav-bar-label="detailData.articletitle"></breadcrumb>

            <div class="content">
                <div class="left">
                    <detail-view :tableData="detailData" :nextPreData="nextPreData"></detail-view>
                </div>

                <div class="right ceiling">
                    <more-news :data="moreData"></more-news>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import breadcrumb from './components/breadcrumb.vue';
import detailView from './components/detailview.vue';
import moreNews from './components/more-news.vue';

import appNode from '@js/app-node';
import CONFIG_PROJECT from '@config/project';

export default {
    head() {
        return {
            title: `${this.detailData.articletitle}·新闻资讯·${CONFIG_PROJECT.title}`,
        }
    },
    name: '',
    components: { breadcrumb, detailView, moreNews },

    watchQuery: true, //监听参数
    async asyncData(context) {
        let [detailData, nextPreData] = await Promise.all([
            appNode.ssrReq
                .call(context, `${context.store.state.api.kjsUrl}/web/article/detail.json`, {
                    guid: context.params.guid,
                })
                .then((data) => data),
            appNode.ssrReq
                .call(context, `${context.store.state.api.kjsUrl}/web/article/getaroundnews.json`, {
                    guid: context.params.guid,
                    keyword: context.query.search,
                })
                .then((data) => data),
        ]);
        return {
            detailData,
            nextPreData, //上下篇
        };
    },

    data() {
        return {
            moreData: [],
        };
    },
    watch: {
        $route(to, from) {
            this.reArray();
            this.doMouthed();
        },

        'detailData.guid': {
            handler(n) {
                if (n) {
                    this.doMouthed();
                }
            },
            deep: true,
        },
    },
    mounted() {
        this.doMouthed();
    },

    methods: {
        reArray() {
            this.detailData = {};
            this.moreData = [];
        },
        doMouthed() {
            this.getMoreData(this.detailData.articletype);
        },

        //更多新闻
        getMoreData(articletype) {
            this.$get(
                `${this.$store.state.api.kjsUrl}/web/article/morenewslist.json`,
                {
                    newstype: articletype,
                },
                (data) => {
                    this.moreData = data.map((item) => ({
                        guid: item.guid,
                        title: item.articletitle,
                    }));
                }
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.detail {
    width: 1200px;
    margin: 0 auto;
    padding-top: 0;
    //定位，实现到达顶部
    .detailPostion {
        position: relative;
        bottom: 80px;
    }
}
.detail-inner {
    width: 1200px;
    margin: 0 auto;

    .content {
        position: relative;

        .left {
            width: 820px;
            // padding: 30px;
        }
        .right {
            position: absolute;
            top: 0;
            right: 0;
            width: 350px;
            height: 380px;
            background-color: white;
        }
    }
}
</style>
